// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25S1V","list":"styles_list__1YgaH","disableSelection":"styles_disableSelection__2CfSn"};